export default {
  SESSION_INFO_LIST_REQUEST: 'APP/SESSION_INFO/SESSION_INFO_REQUEST',
  SESSION_INFO_LIST_SUCCESS: 'APP/SESSION_INFO/SESSION_INFO_SUCCESS',
  SESSION_INFO_LIST_ERROR: 'APP/SESSION_INFO/SESSION_INFO_ERROR',
};
